// Others
import axiosClient from './axiosClient';
import { urlApiQuickBooks } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IQueryParamBase } from '~/utils/interface/common';
import { ICustomerQuickBooks } from '~/utils/interface/quickBooks';

const quickBooksApi = {
  getListCustomerQuickBooks: (params: IQueryParamBase) => {
    const url = urlApiQuickBooks.getListCustomerQuickBooks;
    return axiosClient.get<IBaseResponse<IListDataResponse<ICustomerQuickBooks[]>>>(url, { params });
  },

  getAuthUrl: () => {
    const url = urlApiQuickBooks.getAuthUrl;
    return axiosClient.get<IBaseResponse<string>>(url);
  },

  disconnect: () => {
    const url = urlApiQuickBooks.disconnect;
    return axiosClient.post<IBaseResponse>(url);
  },
};

export default quickBooksApi;
